import { Card, H3 } from "@dgs/core";
import { FC, useMemo } from "react";
import { RegistrationFormSectionResourceTypeCompanionSection } from "../../shared/types";
import { useRegistrationForm } from "../provider/registrationFormProviderContext";
import { toDataField } from "../provider/registrationFormProviderUtils";
import { toGuestAttributeChildrenFromSection } from "../registrationFormUtils";
import { RegistrationCompanionInfo } from "../section/companion/RegistrationCompanionInfo";

interface Props {
	section: RegistrationFormSectionResourceTypeCompanionSection;
}

type ErrorMessages = Record<string, string>;

function filterEntriesByPrefix(entry: ErrorMessages, prefix: string) {
	return Object.entries(entry)
		.filter(([key, value]) => {
			if (key.startsWith(prefix)) {
				return value;
			}
		})
		.reduce((acc, [key, value]) => {
			acc[key.slice(prefix.length)] = value;
			return acc;
		}, {} as ErrorMessages);
}

export const RegistrationCompanionSummary: FC<Props> = ({ section }) => {
	const { errors, filledSteps, companionsByType } = useRegistrationForm();
	const type = companionsByType.find((type) => type.id === section.companionSettings.companionType.id);
	const dataFields = useMemo(() => toGuestAttributeChildrenFromSection(section).map(toDataField), [section]);
	if (!type || type.companions.length === 0) return null;

	return (
		<>
			<H3>{type.pluralLabel}</H3>
			{type.companions.map((companion, index) => {
				const prefix = `companions.${type.singularLabel}${index}.`;
				const companionErrors = errors && filterEntriesByPrefix(errors, prefix);
				return (
					<Card key={index} $color="content" $variant="outlined">
						<RegistrationCompanionInfo
							filledSteps={filledSteps}
							companion={companion}
							dataFields={dataFields}
							errors={companionErrors ?? null}
						/>
					</Card>
				);
			})}
		</>
	);
};
